import request from '@/utils/request'

export function login(username, password, systemCode) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,
      systemCode
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function batchAllocRole(data) {
  return request({
    url: '/admin/role/batchAdd',
    method: 'post',
    data: data
  })
}

export function allocDept(data) {
  return request({
    url: '/admin/allocDept/update',
    method: 'post',
    data: data
  })
}

export function getDeptIds(adminId) {
  return request({
    url: '/admin/allocDept/list/' + adminId,
    method: 'get'
  })
}

export function listByDept(deptId) {
  return request({
    url: '/admin/listByDept/' + deptId,
    method: 'get'
  })
}

export function removeFromDept(deptId, adminId) {
  return request({
    url: '/admin/removeFromDept',
    method: 'post',
    params: { deptId, adminId }
  })
}

export function addToDept(deptId, adminId) {
  return request({
    url: '/admin/addToDept',
    method: 'post',
    params: { deptId, adminId }
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js